import {useState, useEffect} from 'react';
import buildResourcePath from '@lib/buildResourcePath';
import Card from '../edit-page/Card';
import History from '../common/History';
import Assets from '../../Assets';
import HelpSystemInformation from '../common/HelpSystemInformation';
import ProjectAPIService from '@lib/api-services/ProjectApiService';
import Loader from '../common/Loader';

export default function HistoryCard({projectId, helpInfo, title, api, projectEntityName="Project"}) {

    const [audits, setAudits] = useState([]);

    useEffect(() => {
        async function fetch() {
            let response = await api.getHistoricalData(projectId);
            setAudits(response.data.audits)
        }

        fetch()
    }, [])

    const showAllClick = () => {
        window.location.href = buildResourcePath(`${api.endpointControllerName}Audit/Index?id=${projectId}&entityTypeName=${projectEntityName}&title=${title}`)
    }

    const renderCustomButton = () => {
        return (
            <a onClick={() => showAllClick()} className="btn-show-all">{__('Show all')}</a>
        );
    }

    const renderTitle = () => {
        return (
            <div className="card-title">
                <div className="title">
                    <span> {__('Project changes history')}</span>
                    <HelpSystemInformation text={helpInfo}/>
                </div>
                <div className="card-buttons">
                    {renderCustomButton()}
                </div>
            </div>
        )
    }

    return (
        <Card className="history-card" customTitle={() => renderTitle()}>
            {audits.length === 0 ? <Loader fillContainer={true}/> : <History items={audits}/>}
        </Card>
    );
}

